var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Check } from "@epic-ui/icons";
import Chip from "@material-ui/core/Chip";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import mergeRefs from "react-merge-refs";
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette, transitions = _a.transitions;
    return ({
        root: {
            position: "relative",
            transition: transitions.create(["background-color", "box-shadow", "border-color"], { duration: transitions.duration.short }),
        },
        input: {
            cursor: "inherit",
            position: "absolute",
            opacity: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
        outlined: {
            border: "1px solid ".concat(palette.dividerStrong),
            "&&:active": {
                backgroundColor: palette.action.active,
            },
            "&:focus": {
                boxShadow: "unset",
                borderColor: palette.text.primary,
            },
        },
    });
}, { name: "EuiSelectableChip" });
export var SelectableChip = React.forwardRef(function SelectableChip(_a, ref) {
    var _b, _c;
    var label = _a.label, onChange = _a.onChange, checked = _a.checked, className = _a.className, defaultChecked = _a.defaultChecked, _d = _a.inputProps, _e = _d === void 0 ? {} : _d, inputClassName = _e.className, inputProps = __rest(_e, ["className"]), _f = _a.checkedIcon, checkedIcon = _f === void 0 ? React.createElement(Check, { fontSize: "small" }) : _f, props = __rest(_a, ["label", "onChange", "checked", "className", "defaultChecked", "inputProps", "checkedIcon"]);
    var classes = useStyles();
    // Uses either `checked` or `defaultChecked` in the initial render. Then, follows updates to `checked`.
    // This is only for visual purposes and keeps the input uncontrolled.
    var _g = React.useState(typeof checked !== "undefined" ? checked : defaultChecked), isChecked = _g[0], setIsChecked = _g[1];
    React.useEffect(function () {
        if (typeof checked !== "undefined")
            setIsChecked(checked);
    }, [checked]);
    var chipRef = React.useRef(null);
    var handleKeyUp = function (event) {
        props.onKeyUp && props.onKeyUp(event);
        if (event.key === " " || event.key === "Spacebar") {
            event.preventDefault();
            if (chipRef === null || chipRef === void 0 ? void 0 : chipRef.current) {
                chipRef.current.click();
                chipRef.current.focus();
            }
        }
    };
    return (React.createElement(Chip, __assign({ role: "button", "aria-pressed": checked, onKeyUp: handleKeyUp, label: React.createElement(React.Fragment, null,
            label,
            React.createElement("input", __assign({ type: "checkbox", className: clsx(classes.input, inputClassName) }, inputProps, { checked: checked, defaultChecked: defaultChecked, onChange: onChange, tabIndex: -1 }))) }, props, (isChecked
        ? { icon: checkedIcon, variant: "default" }
        : { variant: "outlined" }), { clickable: true, classes: __assign(__assign({}, props.classes), { root: clsx(classes.root, className, (_b = props.classes) === null || _b === void 0 ? void 0 : _b.root), outlined: clsx(classes.outlined, (_c = props.classes) === null || _c === void 0 ? void 0 : _c.outlined) }), component: "label", ref: mergeRefs([ref || null, chipRef]) })));
});
//# sourceMappingURL=SelectableChip.js.map